import { useState } from 'react';
import { Autocomplete, Select } from '@wajeez-web/components/mui';
import { ButtonHeadless, InputLabel, Spin } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useTranslation } from 'react-i18next';
import { AiOutlinePlus } from 'react-icons/ai';
import { useContentSelector } from '@wajeez-web/stores/content';
import { Server } from '@wajeez/wajeez.microservices';
import { ThunkStatus } from '@wajeez-web/stores/base';

interface ComponentComponentTypeFormProps {
  onSubmit: (body: { typeId: string | undefined }) => void;
  onAddButtonClick: () => void;
  componentTypesLookups: {
    data: Server.ComponentTypeOutput[];
    status: ThunkStatus;
  };
}

export const ComponentComponentTypeForm = ({
  onSubmit,
  onAddButtonClick,
  componentTypesLookups,
}: ComponentComponentTypeFormProps) => {
  const [selectedTypeId, setSelectedTypeId] = useState<string | undefined>();
  const [validate, setValidate] = useState(false);

  const { t } = useTranslation();

  const handleSubmit = () => {
    if (!selectedTypeId) {
      setValidate(true);

      return;
    }

    onSubmit({ typeId: selectedTypeId });
  };

  return componentTypesLookups.status === 'loading' ? (
    <Spin />
  ) : (
    <div className="w-full">
      <div className="relative w-[470px] mx-auto flex justify-between items-end">
        <div className="w-full">
          <Autocomplete
            id={`component-type`}
            options={componentTypesLookups.data.map((ct) => {
              return {
                value: ct.id?.toString(),
                label: ct.title,
              };
            })}
            label="Type"
            color="#1f7983"
            required={true}
            value={selectedTypeId}
            onChange={(value) => {
              setSelectedTypeId(value as string);
            }}
            heightClassName="h-[34px]"
          />
          {validate && !selectedTypeId && (
            <div className="absolute top-[100%] right-0 text-[13px] text-red-500">
              <ReturnTranslatedText
                origintext="This field is required"
                text={`general.${'This field is required'}`}
              />
            </div>
          )}
        </div>
        <div className="w-[120px] rtl:mr-4 ltr:ml-4">
          <ButtonHeadless paddingYStyle="py-[6px]" action={onAddButtonClick}>
            <div className="flex justify-center items-center space-s-1 text-white">
              <ReturnTranslatedText
                origintext="New Type"
                text={`buttons.${'New Type'}`}
              />
              <AiOutlinePlus />
            </div>
          </ButtonHeadless>
        </div>
      </div>
      <div className="mt-10 w-[100px] mx-auto">
        <ButtonHeadless paddingYStyle="py-2" action={handleSubmit}>
          <div className="text-white text-[18px]">
            <ReturnTranslatedText
              origintext="Continue"
              text={`buttons.${'Continue'}`}
            />
          </div>
        </ButtonHeadless>
      </div>
    </div>
  );
};
